import React from 'react';

const CotizadorCard = ({ meses, pago, isActive = true }) => {
  return (
    // EL CAMBIO ESTÁ AQUÍ:
    // Quitamos 'group' del contenedor principal y movemos el hover
    // para que sea independiente en cada Card.
   <div className={`flex-none w-[280px] snap-center bg-white border-2 rounded-3xl p-6 transition-all duration-300 ease-in-out ${
  isActive 
    ? "border-gray-100 shadow-sm hover:border-yellow-500 hover:shadow-2xl hover:-translate-y-2 cursor-pointer" 
    : "border-gray-50 opacity-50"
}`}>
      <div className="flex justify-between items-center mb-4">
        <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">
          Plazo
        </span>
        <span className="bg-slate-900 text-white text-[11px] font-bold px-3 py-1 rounded-lg">
          {meses} MESES
        </span>
      </div>

      <p className="text-gray-400 text-[10px] font-bold uppercase tracking-tighter">Pago mensual</p>
      
      {/* EL CAMBIO ESTÁ AQUÍ TAMBIÉN: */}
      {/* Quitamos 'group-hover' y ponemos 'hover' normal para el color */}
      <h3 className={`text-3xl font-black transition-colors ${
        isActive 
          ? "text-gray-900 hover:text-yellow-600" // <-- Color individual
          : "text-gray-400"
      }`}>
        ${pago.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </h3>
      
      <div className="mt-6 pt-4 border-t border-gray-50 flex justify-between items-center">
         <span className="text-[9px] font-bold text-gray-300 italic uppercase tracking-widest text-wrap w-24">
           Seminuevos Sonora
         </span>
         {isActive && <div className="h-2 w-2 rounded-full bg-green-400 animate-pulse"></div>}
      </div>
    </div>
  );
};

export default CotizadorCard;